/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_X_Offset_LabelInputs */



/**
* | output |
* | --- |
* | "Horizontal (X) Offset" |
*
* @param {Style_Guide_Manager_Position_X_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_x_offset_label = /** @type {((inputs?: Style_Guide_Manager_Position_X_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_X_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decalage horizontal (X)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Horizontaler (X) Versatz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset orizzontale (X)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Горизонтальное (X) смещение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento horizontal (X)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("水平 (X) 偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("水平（X）オフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्षैतिज (X) ऑफ़सेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento horizontal (X)")
	return /** @type {LocalizedString} */ ("Horizontal (X) Offset")
});